const PlaylistEvents = [
    'playlistInfo',
    'playlistNext',
    'playlistPrevious',
    'playlistGoTo',
    'playlistMetadata',
];

export default PlaylistEvents;



// WEBPACK FOOTER //
// ./src/js/events/playlist-events.js